import React, { useEffect, useState } from 'react'

/**
 * Rotates `words` every `intervalMs`. Provides `activeIndex` to children.
 * Visual stack: children should render words in an inline-grid so width matches longest word.
 */
const HeroRotatingWord = ({ words, intervalMs, children }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined
    }
    const id = setInterval(() => {
      setActiveIndex(i => (i + 1) % words.length)
    }, intervalMs)
    return () => clearInterval(id)
  }, [intervalMs, words.length])

  return children({ activeIndex, words })
}

export default HeroRotatingWord
